module.exports = __webpack_public_path__ + "static/NavImg01-8d24c17061461f78193cfb90f93e9ac0.jpg";